import { render, staticRenderFns } from "./scope32.vue?vue&type=template&id=f64aea4a&scoped=true"
import script from "./scope32.vue?vue&type=script&lang=js"
export * from "./scope32.vue?vue&type=script&lang=js"
import style0 from "./scope32.vue?vue&type=style&index=0&id=f64aea4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64aea4a",
  null
  
)

export default component.exports